<template>
  <div class="container" ref="container">
    <div class="chart">
      <div class="tick" :style="{ left: `calc(${chartData.value}% - 5px)` }"></div>
      <div v-for="n of split" :key="n"></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.container {
  width: 100%;
  justify-content: flex-start;
  display: flex;
}
.chart {
  flex: 1;
  height: 20px;
  border: 1px solid $instruction-color;
  position: relative;
  display: flex;
  & > div:not(.tick) {
    flex: 1;
    height: 20px;
    border-right: 1px dashed $instruction-color;
  }
  & > div:last-child {
    border-right: 0;
  }
}
.tick {
  position: absolute;
  top: 5px;
  width: 10px;
  height: 10px;
  background: $brand-color !important;
  z-index: 98;
  border-radius: 50%;
}
</style>
<script lang="ts">
import {} from "d3-color";
import { Prop, Ref } from "vue-property-decorator";
import ChartMixin from "../../helpers/mixins/chart";
export default class LevelChart extends ChartMixin {
  @Ref("container") readonly container!: HTMLElement;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ type: Object, required: true }) chartData: any;
  @Prop({ type: Number }) split = 5;
}
</script>
